import { OrgModel } from 'api/Orgs/types';

import { ColumnsType } from 'antd/es/table';

const useOrgNamedModelColumns = () => {
  const columns: ColumnsType<OrgModel> = [
    {
      title: 'Model Name',
      dataIndex: 'modelName',
      key: 'modelName',
    },
    {
      title: 'Model API',
      dataIndex: 'modelApiName',
      key: 'modelApiName',
    },
  ];

  return { columns };
};

export default useOrgNamedModelColumns;
